import React from "react";
import { Container, Row, Col, Card } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

const WatchdogIntro = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <Container fluid className="py-5 watchdog-intro-docs">
      <Row className="justify-content-center mb-4">
        <Col lg={8}>
          <Card className="shadow-sm border-0 rounded-lg p-4">
            <Card.Body>
              <Card.Title className="display-6 mb-3">
                {t("documentation.watchdog.title")}
              </Card.Title>
              <Card.Text className="text-muted mb-3">
                {t("documentation.watchdog.description")}
              </Card.Text>

              {/* ✅ Overview List with Anchor Links */}
              <ul className="overview-list">
                <li>
                  <a
                    className="text-decoration-none"
                    onClick={() =>
                      navigate("/docs/watchdog/add", { replace: true })
                    }
                  >
                    {t("documentation.watchdog.items.add")}
                  </a>
                </li>
                <li>
                  <a
                    className="text-decoration-none"
                    onClick={() =>
                      navigate("/docs/watchdog/remove", { replace: true })
                    }
                  >
                    {t("documentation.watchdog.items.remove")}
                  </a>
                </li>
                <li>
                  <a
                    className="text-decoration-none"
                    onClick={() =>
                      navigate("/docs/watchdog/reset", { replace: true })
                    }
                  >
                    {t("documentation.watchdog.items.reset")}
                  </a>
                </li>
                <li>
                  <a
                    className="text-decoration-none"
                    onClick={() =>
                      navigate("/docs/watchdog/block-suspension", {
                        replace: true,
                      })
                    }
                  >
                    {t("documentation.watchdog.items.suspensionBlock")}
                  </a>
                </li>
                <li>
                  <a
                    className="text-decoration-none"
                    onClick={() =>
                      navigate("/docs/watchdog/alerts", { replace: true })
                    }
                  >
                    {t("documentation.watchdog.items.alerts")}
                  </a>
                </li>
              </ul>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default WatchdogIntro;
